import {z} from "zod";
import {SanitizedEventQuestion} from "../../services/api/event/eventQuestion/getEventQuestions/getEventQuestions";

function createSchemaFromEventQuestions(questions: SanitizedEventQuestion[]) {
  const schema: Record<string, z.ZodTypeAny> = {};

  for (const q of questions) {
    let validation: z.ZodTypeAny;

    switch (q.type) {
      case "text":
        validation = z.string().min(1, "Required");
        break;
      case "email":
        validation = z.string().email().min(1, "Required");
        break;
      case "number":
        validation = z.number().min(0, "Required");
        break;
      case "select":
        validation = z.enum(
          (q.options?.map((o) => o.label) as [string, ...string[]]) || [],
          {
            errorMap: () => ({message: "Required"}),
          }
        );
        break;
      default:
        validation = z.any();
    }

    schema[q.id] = validation;
  }
  return schema;
}

export function createOrderFormSchema(questions: SanitizedEventQuestion[]) {
  const customQuestionsSchema = createSchemaFromEventQuestions(questions);
  return z.object(customQuestionsSchema);
}

export type OrderFormData = z.infer<ReturnType<typeof createOrderFormSchema>>;

export const generateDefaultFormValues = (
  questions: SanitizedEventQuestion[]
) => {
  const fields: OrderFormData = {};
  questions.forEach((q) => {
    switch (q.type) {
      case "text":
        fields[q.id] = "";
        break;
      case "number":
        fields[q.id] = 0;
        break;
      case "select":
        fields[q.id] = "";
        break;
      default:
        fields[q.id] = "";
    }
  });
  return fields;
};

export const sanitizeRawOrderAnswers = (formData: OrderFormData) =>
  Object.entries(formData).map(([questionId, answer]) => ({
    questionId: Number(questionId),
    answer: String(answer),
  }));
